import React, { useRef, useState, useEffect } from "react";
import {
  Container,
  TextField,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";
import Search from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";

import SearchResult from "./Components/SearchResult";
import univData from "../../univdata.json";

import HomeLogo from "../../welcome-page.png";

const univ = [
  { name: "National University of Singapore" },
  { name: "Nanyang Technological University" },
  { name: "Singapore Management University" },
  { name: "Singapore Institute of Management" },
  { name: "Nanyang Academy of Fine Arts" },
  { name: "LASALLE College of the Arts" },
];

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    position: "relative",
    top: "60px",
    paddingTop: "10px",
    marginTop: "100px",
  },
  homelogo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "40%",
  },
  inputBoxes: {
    marginTop: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    padding: 4,
  },
  iconButton: {
    padding: 10,
  },
  searchResult: {
    marginTop: theme.spacing(15),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export default function Home() {
  const universityRef = useRef();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [index, setIndex] = useState();
  const timer = useRef();

  const classes = useStyles();

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    }
  },[]);

  function handleSubmit(e) {
    e.preventDefault();
    const searchWord = universityRef.current.value ? universityRef.current.value : "";
    const indexFound = univData.findIndex((univ) => univ.name === searchWord);
    setIndex(indexFound);
    if (!loading) {
      setSuccess(false);
      setError(false);
      setLoading(true);
      timer.current = window.setTimeout(() => {
        if (indexFound === -1){
          setError(true);
        } else {
          setSuccess(true);
        }
        setLoading(false);
      }, 500);
    }

  }

  return (
    <Container maxWidth="lg" className={classes.main}>
      <img src={HomeLogo} alt="home-logo" className={classes.homelogo} />
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.inputBoxes}>
          <Autocomplete
            className={classes.input}
            id="home-search-bar"
            freeSolo
            options={univ.map((option) => option.name)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search University"
                variant="outlined"
                inputRef={universityRef}
              />
            )}
          />
          <IconButton
            type="submit"
            className={classes.iconButton}
            aria-label="search"
            disabled={loading}
          >
            <Search fontSize="large" />
          </IconButton>
        </div>
      </form>
      <div className={classes.searchResult}>
        {error && <Alert severity="error">No University Found</Alert>}
        {loading && <CircularProgress />}
        {success && <SearchResult data={univData[index]} />}
      </div>
    </Container>
  );
}
